import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { EnvironmentVariablesService } from './app/core/services/environment-variables.service';
import { APP_INITIALIZER, inject } from '@angular/core';

export function initializeApp(envService: EnvironmentVariablesService) {
  return () => envService.loadConfig().toPromise();
}

const extendedAppConfig = {
  ...appConfig,
  providers: [
    ...(appConfig.providers || []),
    {
      provide: APP_INITIALIZER,
      useFactory: () => initializeApp(inject(EnvironmentVariablesService)),
      deps: [EnvironmentVariablesService],
      multi: true,
    },
  ],
};

bootstrapApplication(AppComponent, extendedAppConfig).catch((err) =>
  console.error(err)
);
